module.exports = __webpack_public_path__ + "media/close.e1db13a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/bouncy/assets/close.svg
// module id = ./src/templates/bouncy/assets/close.svg
// module chunks = 0